import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import { Link } from 'react-router-dom';
import TruckTerminal from './Location/TruckTerminal';
import { withStyles } from '@material-ui/core/styles';

const styles = {
	container: {
		width: '100%',
		tableLayout: 'auto',
	},
	card: {
		maxWidth: 240,
		minHeight: 80,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
};

class Locations extends Component {
	render() {
		const { classes, match, ...other } = this.props;

		const locationTypeId = _.get(match, 'params.locationTypeId');
		if (locationTypeId === 'truck-terminal') {
			return <TruckTerminal {...other} />;
		}

		return (
			<div className={classes.container}>
				<Link to="/location/truck-terminal">
					<Card classes={{ root: classes.card }}>Truck Terminals</Card>
				</Link>
			</div>
		);
	}
}

Locations.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Locations);
